import { BLSFeedback } from "../pages/BLSFeedback";
import {
  CustomerManagement,
  CustomerDetails,
} from "../pages/CustomerManagement";
import {
  NotificationManagement,
  ViewNotificationDetails,
  EditNotification,
  AddNotification,
} from "../pages/NotificationManagement";
import { ClickAnalytics, ClickAnalyticsDetails } from "../pages/ClickAnalytics";

import { APP_ROUTES } from "../helpers/routeHelpers";
import { Roles } from "../constants";
import { EditProfile, ChangePassword } from "../pages/Account";

let { Admin } = Roles;

const authProtectedRoutes = [
  // BLSFeedback
  {
    path: APP_ROUTES.BLS_FEEDBACK,
    component: BLSFeedback,
    permissions: [Admin],
    exact: true,
  },
  // Customer Management
  {
    path: APP_ROUTES.CUSTOMER_MANAGEMENT,
    component: CustomerManagement,
    permissions: [Admin],
    exact: true,
  },
  {
    path: `${APP_ROUTES.CUSTOMER_DETAILS}/:id`,
    component: CustomerDetails,
    permissions: [Admin],
    exact: false,
  },
  // Notification Management
  {
    path: APP_ROUTES.NOTIFICATION_MANAGEMENT,
    component: NotificationManagement,
    permissions: [Admin],
    exact: true,
  },
  {
    path: `${APP_ROUTES.NOTIFICATION_DETAILS}/:id`,
    component: ViewNotificationDetails,
    permissions: [Admin],
    exact: false,
  },
  {
    path: `${APP_ROUTES.EDIT_NOTIFICATION}/:id`,
    component: EditNotification,
    permissions: [Admin],
    exact: false,
  },
  {
    path: APP_ROUTES.ADD_NOTIFICATION,
    component: AddNotification,
    permissions: [Admin],
    exact: false,
  },
  {
    path: APP_ROUTES.EDIT_PROFILE,
    component: EditProfile,
    permissions: [Admin],
    exact: true,
  },
  {
    path: APP_ROUTES.CHANGE_PASSWORD,
    component: ChangePassword,
    permissions: [Admin],
    exact: true,
  },
  {
    path: APP_ROUTES.CLICK_ANALYTICS,
    component: ClickAnalytics,
    permissions: [Admin],
    exact: true,
  },
  {
    path: `${APP_ROUTES.CLICK_ANALYTICS_DETAILS}/:date`,
    component: ClickAnalyticsDetails,
    permissions: [Admin],
    exact: false,
  },
];

export { authProtectedRoutes };
